(function (window, document) {
  'use strict';

  var EVENT_IDS = {
    CARD: 'allos_cinema_theater_card_click',
    DETAIL: 'allos_cinema_theater_detail_view',
  };

  var DETAIL_TYPE = 'cinema';
  var DETAIL_SENT = { value: false };
  var LUM_TRACK_POLL_MS = 150;
  var LUM_TRACK_WAIT_MS = 90000;

  function isLumTrackReady() {
    return typeof window.lum_track === 'function';
  }

  function safeLumTrack(eventId, data) {
    if (!isLumTrackReady()) {
      return;
    }
    try {
      window.lum_track('event', eventId, data);
    } catch (e) {
      /* fail silently */
    }
  }

  function emitWhenReady(eventId, data) {
    var api = window.AllosLumExperience;
    if (api && typeof api.emitWhenReady === 'function') {
      api.emitWhenReady(eventId, data);
      return;
    }

    if (isLumTrackReady()) {
      safeLumTrack(eventId, data);
      return;
    }

    var deadline = Date.now() + LUM_TRACK_WAIT_MS;
    var timer = window.setInterval(function () {
      if (isLumTrackReady()) {
        window.clearInterval(timer);
        safeLumTrack(eventId, data);
        return;
      }
      if (Date.now() > deadline) {
        window.clearInterval(timer);
      }
    }, LUM_TRACK_POLL_MS);
  }

  function normalizedText(raw) {
    if (!raw || typeof raw !== 'string') {
      return '';
    }
    return raw.replace(/\s+/g, ' ').trim();
  }

  function prefixedContentName(name) {
    var safeName = normalizedText(name);
    return safeName ? '[Cinema] ' + safeName : '';
  }

  function isSlideLabel(value) {
    return /^\d+\s*\/\s*\d+$/.test(normalizedText(value));
  }

  function findFromNode(node, selectors) {
    if (!node) {
      return '';
    }
    for (var i = 0; i < selectors.length; i++) {
      var match = node.querySelector(selectors[i]);
      if (!match) {
        continue;
      }
      var txt = normalizedText(match.textContent || match.getAttribute('alt') || '');
      if (txt) {
        return txt;
      }
    }
    return '';
  }

  function movieNameFromClickable(node) {
    if (!node) {
      return '';
    }

    var fromAttr = normalizedText(
      node.getAttribute('data-movie-name') ||
      node.getAttribute('title') ||
      ''
    );
    if (fromAttr) {
      return fromAttr;
    }

    var ariaLabel = normalizedText(node.getAttribute('aria-label'));
    if (ariaLabel && !isSlideLabel(ariaLabel)) {
      return ariaLabel;
    }

    var fromChildAttr = normalizedText(
      (node.querySelector('[data-movie-name]') || {}).getAttribute
        ? node.querySelector('[data-movie-name]').getAttribute('data-movie-name')
        : ''
    );
    if (fromChildAttr) {
      return fromChildAttr;
    }

    var fromTitle = findFromNode(node, [
      '.cinema-list__title',
      '.dsa-cinema__title',
      '.dsa-text-heading-6',
      '.dsa-text-heading-5',
      'h5',
      'h4',
      'h3',
    ]);
    if (fromTitle) {
      return fromTitle;
    }

    var img = node.querySelector('img[alt]');
    if (img) {
      return normalizedText(img.getAttribute('alt'));
    }

    return '';
  }

  function emitCinemaCardClick(name) {
    emitWhenReady(EVENT_IDS.CARD, {
      cinema_theater_type: DETAIL_TYPE,
      cinema_theater_name: prefixedContentName(name),
    });
  }

  function onCinemaClick(event) {
    if (event.__lumCinemaTracked) {
      return;
    }

    var t = event.target;
    if (!t || !t.closest) {
      return;
    }

    var clickRoot = t.closest(
      '#cinema-home-section #cinema-carousel a, ' +
      '#cinema-list-section #cinema-list a, ' +
      '.cinema_home .cinema__list a, ' +
      '.dsa-carousel-cinema a'
    );

    if (!clickRoot) {
      return;
    }

    var href = clickRoot.getAttribute('href') || '';
    var className = clickRoot.className || '';
    if (
      className.indexOf('callModalBuy') >= 0 ||
      className.indexOf('cinema-list__btn-play') >= 0 ||
      clickRoot.getAttribute('target') === '_blank' ||
      href.indexOf('javascript:') === 0
    ) {
      return;
    }

    var cardContainer = clickRoot.closest('#cinema-list .cinema-list__item, .swiper-slide, .cinema__item') || clickRoot;
    var name = movieNameFromClickable(cardContainer);
    emitCinemaCardClick(name);
    event.__lumCinemaTracked = true;
  }

  function isCinemaDetailPage() {
    return !!(
      document.querySelector('#cinema-details-section') ||
      document.querySelector('script[src*="/cinema/movie-details.js"]')
    );
  }

  function cinemaDetailName() {
    var section = document.querySelector('#cinema-details-section');
    if (!section) {
      return '';
    }

    var title = findFromNode(section, [
      '.cinema-list__title',
      '.dsa-text-heading-5',
      '.dsa-text-heading-4',
      'h1',
      'h2',
      'h3',
    ]);
    if (title) {
      return title;
    }

    return normalizedText((document.querySelector('#movieTrailer-title') || {}).textContent || '');
  }

  function tryTrackCinemaDetailView() {
    if (DETAIL_SENT.value || !isCinemaDetailPage()) {
      return;
    }

    var name = cinemaDetailName();
    if (!name) {
      return;
    }

    DETAIL_SENT.value = true;
    emitWhenReady(EVENT_IDS.DETAIL, {
      cinema_theater_type: DETAIL_TYPE,
      cinema_theater_name: prefixedContentName(name),
    });
  }

  function watchCinemaDetailName() {
    if (!isCinemaDetailPage()) {
      return;
    }

    tryTrackCinemaDetailView();
    if (DETAIL_SENT.value || typeof MutationObserver !== 'function') {
      return;
    }

    var target = document.querySelector('#cinema-details-section') || document.body;
    var observer = new MutationObserver(function () {
      tryTrackCinemaDetailView();
      if (DETAIL_SENT.value) {
        observer.disconnect();
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    window.setTimeout(function () {
      if (!DETAIL_SENT.value) {
        observer.disconnect();
      }
    }, 30000);
  }

  function bootstrap() {
    document.addEventListener('click', onCinemaClick, true);
    watchCinemaDetailName();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})(window, document);
